module.exports = __webpack_public_path__ + "img/Z82_13.9779cc26.jpg";